import { IdLoca } from "../../utils/i18n/IdLoca";
import { IdIcon } from "../generic/icon/IdIcon";
import { IdActionButtonEntries } from "../hud-action-button/IdActionButtonEntries";
export var mapPendingInventoryActionToInfo = new Map()
    .set(IdActionButtonEntries.PIPlayerLeagueReward, {
    description: IdLoca.tournamentReward_player,
    icon: IdIcon.Tournament_rewards_Inc,
    title: IdLoca.congratulations,
})
    .set(IdActionButtonEntries.PICoopLeagueReward, {
    description: IdLoca.tournamentReward_coop_summedThresholds,
    icon: IdIcon.Tournament_rewards_Inc,
    title: IdLoca.congratulations,
})
    .set(IdActionButtonEntries.PISystem, {
    description: IdLoca.compensationDialog_desc,
    icon: IdIcon.GiftIcn,
    title: IdLoca.compensationDialog_title,
})
    .set(IdActionButtonEntries.PICollectLeagueReward, {
    description: IdLoca.tournamentReward_coop_summedThresholds,
    icon: IdIcon.Tournament_rewards_Inc,
    title: IdLoca.congratulations,
})
    .set(IdActionButtonEntries.PICollectLeagueReward, {
    description: IdLoca.thresholdReward_collectingEvent_desc,
    icon: IdIcon.Tournament_rewards_Inc,
    title: IdLoca.reward_collectingEvent_title,
})
    .set(IdActionButtonEntries.PIPlayerLeagueRanking, {
    // TODO: Conditional description, refer to mobile farm.
    description: IdLoca.tournamentReward_player_summedRankings,
    icon: IdIcon.Tournament_rewards_Inc,
    title: IdLoca.congratulations,
})
    .set(IdActionButtonEntries.PICoopLeagueRanking, {
    // TODO: Conditional description, refer to mobile farm.
    description: IdLoca.tournamentReward_coop_summedRankings,
    icon: IdIcon.Tournament_rewards_Inc,
    title: IdLoca.congratulations,
})
    .set(IdActionButtonEntries.PICollectLeagueRanking, {
    description: IdLoca.rankingReward_collectingEvent_desc,
    icon: IdIcon.Tournament_rewards_Inc,
    title: IdLoca.reward_collectingEvent_title,
})
    // TODO: These are not part of pending inventory -to be addressed in action button story
    .set(IdActionButtonEntries.PICafeGift, {
    description: IdLoca.cafeCelebration_desc,
    icon: IdIcon.CustomerSatisfactionIcn,
    title: IdLoca.cafeCelebration_title,
})
    .set(IdActionButtonEntries.PIPurchasePointsReward, {
    description: IdLoca.purchasePointsEvent_reward_desc,
    icon: IdIcon.PointsIcn,
    title: IdLoca.purchasePointsEvent_reward_title,
})
    .set(IdActionButtonEntries.PISatisfaction, {
    description: IdLoca.cafeAndStore_thresholdRewardDesc,
    icon: IdIcon.CustomerSatisfactionIcn,
    title: IdLoca.cafeAndStore_thresholdRewardTitle,
})
    .set(IdActionButtonEntries.PISkyGift, {
    description: IdLoca.launchGiftDialog_desc,
    icon: IdIcon.TournamentRankingIcn,
    title: IdLoca.welcomeGift,
})
    // DO NOT IMPLEMENT SONY GIFT
    .set(IdActionButtonEntries.PIWelcomeBack, {
    description: IdLoca.welcomeBackGift_desc,
    icon: IdIcon.GiftIcn,
    title: IdLoca.welcomeBackGift_title,
})
    .set(IdActionButtonEntries.PI_AnniversaryGift, {
    description: IdLoca.ggsAnniversary10_desc,
    icon: IdIcon.GiftIcn,
    title: IdLoca.ggsAnniversary10_title,
})
    .set(IdActionButtonEntries.Trader, {
    description: IdLoca.rewardDialog_traderEvent_desc,
    icon: IdIcon.GiftIcn,
    title: IdLoca.congratulations,
})
    .set(IdActionButtonEntries.PIBirthdayGift, {
    description: IdLoca.birthdayCelebration_desc,
    icon: IdIcon.GiftIcn,
    title: IdLoca.birthdayCelebration_title,
});
// For more information on how this was decided, refer to mobile farm PendingInventoryActionButtonElement.cs



//////////////////
// WEBPACK FOOTER
// ./src/features/pending-inventory/mapPendingInventoryActionToInfo.ts
// module id = 2291
// module chunks = 3